type errorMessageCustomLink = {
  pathname?: string
  redirectTo?: string
  text?: string
}

export type ErrorMessageConfig = {
  message: string
  showErrorHeading?: boolean
  includeCustomerCare?: boolean
  customLink?: errorMessageCustomLink
}

export const CHECKOUT_ERROR_MESSAGES: Record<string, ErrorMessageConfig> = {
  'ERROR_GENERAL': {
    message: 'Unfortunately, there has been an error trying to place Order, please try again later.',
    showErrorHeading: true,
    includeCustomerCare: true,
  },
  'BONUSCARD_ERROR_GENERAL': {
    message: 'Unfortunately, there has been an error trying to top up your Bonus Card, please try again later.',
    showErrorHeading: true,
    includeCustomerCare: true,
  },
  'THREEDSECURE_GENERAL': {
    message: 'We are having trouble placing your order at the moment. Your credit or debit card have not been charged. Please try again later.',
    includeCustomerCare: true,
  },
  'PAYMENT_ERROR': {
    message: 'There was a problem with your payment which means your order has NOT been completed. Please check your card details and ensure you have the full funds available in your account.',
  },
  'VERIFICATION_FAILED': {
    message: 'Credit Card Verification Failed',
  },
  'THREEDSECURE_CANCELLED': {
    message: "You'll need to use 3D Secure to pay for your order. If you can't use 3D Secure then please pay with a different payment method.",
  },
  'CVV_ERROR': {
    message: 'Card details are incorrect, please try again.',
  },
  'DELIVERY_STORE_ID_VALIDATION_ERROR': {
    message: 'Unfortunately, there has been an error trying to place your order. To process the order, you will need to ', // handled separately in checkout-error-message.tsx
    showErrorHeading: true,
    includeCustomerCare: true,
    customLink: {
      pathname: '/book-delivery',
      redirectTo: '/basket',
      text: 'book a new delivery slot here.' 
    }
  }
}
